/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { SurveyListResponse } from '../model/surveydetailinfo';
import { SurveyService } from '../services/survey.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonConstants } from '../../../../common/constants/common-constants';


@Component({
  selector: 'zsd-surveylist',
  templateUrl: '../view/surveylist.component.html',
  styleUrls: ['../view/surveylist.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SurveyListComponent implements OnInit {
  surveyListResponse: SurveyListResponse[];
  isSurveylist: boolean;
  pathUrl: string;
  id: number;
  requestId: number;
  surveyCount: number;

  constructor(private surveyService: SurveyService, private router: Router,
    private _Activatedroute: ActivatedRoute) {
  }
  ngOnInit() {
    this.requestId =  this._Activatedroute.snapshot.queryParams['requestId'];
    this._Activatedroute.params.subscribe(params => {
      this.id = params['id'];
  });
    this.getSurveylist();

  }
  getSurveylist() {
    this.surveyService.getSurveyList().subscribe(
      (surveyResponse: SurveyListResponse[]) => {
        if (surveyResponse) {
          this.surveyListResponse = surveyResponse;
          this.surveyCount = this.surveyListResponse.length;
          if (this.surveyCount === 0) {
            this.surveyService.surveyListCount(true);
          } else { this.surveyService.surveyListCount(false); }
        }
      },
      err => {
        console.error(err.error);
      });

  }
  openDetailView(survey: SurveyListResponse) {
    this.pathUrl = CommonConstants.SURVEY_COMPONENT + '/' + survey.surveyId;
    if (survey.requestId) {
      this.router.navigateByUrl('/survey', { skipLocationChange: true }).then(() =>
        this.router.navigate([this.pathUrl], { queryParams: { requestId: survey.requestId } }));
    } else {
      this.router.navigateByUrl('/survey', { skipLocationChange: true }).then(() =>
        this.router.navigate([this.pathUrl]));
    }
  }
}
